import GlobalLoader from './GlobalLoader'

export default GlobalLoader
